// Centralized react-pdf / pdf.js configuration. Import this module for its side
// effects before rendering <Document>/<Page> so the worker is wired up and the
// text/annotation layer styles are loaded. Kept in one place so a future
// PowerPoint viewer (decks converted to PDF server-side) can reuse it.
import { pdfjs } from 'react-pdf'

import 'react-pdf/dist/Page/AnnotationLayer.css'
import 'react-pdf/dist/Page/TextLayer.css'

// Vite bundles the worker as an asset and returns a hashed URL for it. pdfjs-dist
// v5 ships an ESM worker (.mjs). Building the URL relative to this module lets
// Vite fingerprint it rather than relying on a CDN (which would break offline and
// add a third-party dependency to a core learning flow).
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString()
